import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Box, Stack, Typography } from "@mui/material";
import { useModal } from "mui-modal-provider";
import { useCallback, useEffect, useRef, useState } from "react";
import usePdf from "../../../hooks/useCriminalHistory";
import { getS3Url, stripS3Prefix } from "../../../utils/s3";
import DeleteCriminalHistoryModal from "./DeleteCriminalHistoryModal";

import { uploadImageToS3 } from "../../components/common/uploadImages";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import { useSnackbarHelper } from "../../components/Snackbar";
import BasicButton from "../../components/buttons/BasicButton";
import UploadDpsReport from "./UploadDpsReport";
import useAuth from "../../../hooks/useAuth";
// import useCases from "../../../hooks/useCases";

function CriminalHistory({ caseData }: any) {
  const showSnackbar = useSnackbarHelper();
  const { request } = useAuth();

  const { addPdf, casePdf, isLoading } = usePdf({
    caseId: caseData?._id,
  });

  // const { uploadDps, isUploadingDps } = useCases(caseData?._id);

  const [submitLoading, setSubmitLoading] = useState(true);

  const { showModal } = useModal();
  const inputRef = useRef<HTMLInputElement>(null);

  const dpsURL = caseData?.dpsReportURL;

  useEffect(() => {}, [caseData]);

  const handleDelete = useCallback(
    (data: any) => {
      const modal: any = showModal(DeleteCriminalHistoryModal, {
        onClose: () => modal.hide(),
        id: data?._id,
        data: data,
        caseId: caseData?._id,
      });
    },

    //eslint-disable-next-line
    [showModal],
  );

  const handleBoxClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const allowedTypes = ["application/pdf"];
    const allowedExtensions = [".pdf"];

    if (
      !allowedTypes.includes(file.type) &&
      !allowedExtensions.some((ext) => file.name.toLowerCase().endsWith(ext))
    ) {
      // Clear the input so the user can re-select a valid file
      event.target.value = "";
      return showSnackbar(
        "Only PDF files are accepted. Please upload a valid PDF document.",
        "error",
      );
    }

setSubmitLoading(true);
    const data = {
      file: file,
      caseId: caseData?.caseId,
      inmateName: caseData?.contactId?.inmate?.name
        ? caseData?.contactId?.inmate?.name
        : "County_Inmate",
      folderName: "Report",
      request,
    };

    let res;
    try {
      res = await uploadImageToS3(data);
    } catch (error: any) {
      setSubmitLoading(false);
      event.target.value = "";
      return showSnackbar(error?.message || "Upload failed", "error");
    }

    const fileLocation = res?.Location;

    if (fileLocation) {
      const data = {
        fileUrl: stripS3Prefix(fileLocation),
        caseId: caseData?._id,
      };

      const response = await addPdf(data);
      const fileUrl = response?.data?.fileUrl;

      if (fileUrl) {
        const message = "Criminal History added successfully";
        showSnackbar(message, "success");
      }
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setSubmitLoading(false);
    }, 500);
  }, []);

  const handleUploadDps = useCallback(() => {
    const modal: any = showModal(UploadDpsReport, {
      onClose: () => modal.hide(),
      caseData,
    });
  }, [showModal]);

  if (isLoading || submitLoading) {
    return <TableSkeleton />;
  }

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <BasicButton
          label={!dpsURL || dpsURL?.length === 0 ? "Upload DPS" : "Change DPS"}
          variant="contained"
          color="success"
          // onClick={() => {
          //   handleRiskItemForm(caseId?.id);
          // }}
          onClick={() => handleUploadDps()}
        />
      </Box>

      <Stack
        sx={{
          // border: "1px solid",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 350px)",
        }}
      >
        {!dpsURL || dpsURL?.length === 0 ? (
          <Box
            onClick={handleBoxClick}
            sx={{
              border: "2px dashed gray",
              borderRadius: "8px",
              width: "fit-content",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              // cursor: "pointer",
              transition: "border-color 0.2s",
              padding: 10,
              paddingX: 20,
            }}
          >
            <input
              ref={inputRef}
              type="file"
              accept="application/pdf"
              style={{ display: "none" }}
              onChange={handleFileChange}
              disabled
            />
            <PictureAsPdfIcon sx={{ fontSize: 40, color: "gray" }} />
            <Typography variant="body1" color="textSecondary">
              No DPS report
            </Typography>
          </Box>
        ) : (
          <>
            <iframe
              title="PDF Viewer"
              // src={`http://localhost:8000/pdf/${casePdf?.document}`}
              src={getS3Url(dpsURL)}
              style={{ width: "99%", height: "calc(100vh - 345px)" }}
            />
            {/* <Grid container>
            <Grid item xs={12}>
              {" "}
              <Button
                color="error"
                variant="outlined"
                sx={{ float: "right", mr: 1, mt: 1 }}
                onClick={() => {
                  handleDelete(casePdf);
                }}
              >
                Remove
              </Button>
            </Grid>
          </Grid> */}
          </>
        )}
      </Stack>
    </Box>
  );
}

export default CriminalHistory;
